import { render } from "./VerifiCodeDialog.vue?vue&type=template&id=0e4a6354&ts=true"
import script from "./VerifiCodeDialog.vue?vue&type=script&lang=ts"
export * from "./VerifiCodeDialog.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__